import util from '../../common/util'

export default {
  methods: {
    validatorForm(register) {
      const {
        // eslint-disable-next-line
        customer_mobile,
        // eslint-disable-next-line
        customer_name,
        // eslint-disable-next-line
        min_buy_car_budget,
        // eslint-disable-next-line
        max_buy_car_budget
      } = register
      // eslint-disable-next-line
      if (!customer_name) {
        this.$message.fail('客户姓名为必填，请检查')
        return false
      }
      // eslint-disable-next-line
      if (customer_mobile && !util.regexpMap.regexp_mobile.test(customer_mobile)) {
        this.$message.fail('手机号格式错误，请检查')
        return false
      }
      // eslint-disable-next-line
      if (+min_buy_car_budget > +max_buy_car_budget) {
        this.$message.fail('购车预算最大值不能小于最小值')
        return false
      }
      // eslint-disable-next-line
      const minEmpyt = util.isNumberEmpty(min_buy_car_budget)
      // eslint-disable-next-line
      const maxEmpyt = util.isNumberEmpty(max_buy_car_budget)
      if (!((minEmpyt && maxEmpyt) || (!minEmpyt && !maxEmpyt))) {
        this.$message.fail('购车预算如果填写,则必须填写两个输入框')
        return false
      }
      return true
    },
    // specails 数组中属性转换为*1000000 = number 其他的都转换为空
    // 这里的 obj[key] 一定是字符串 所以不用判断'0'的情况
    formatParams(obj, specails) {
      for (const key in obj) {
        if (obj[key] === '') delete obj[key]
        if (specails.includes(key) && obj[key]) {
          obj[key] = util.wanToFen(obj[key])
        }
      }
    }
  }

}
